import { withDefaults } from "@/lib/sections";
import { SectionShell, SectionHeading, Img } from "./shared";

export const GallerySection = ({ id, content }) => {
  const c = withDefaults("gallery", content);
  return (
    <SectionShell id={`s-${id}`} testId={`custom-section-${id}`}>
      <SectionHeading eyebrow={c.eyebrow} title={c.title} subtitle={c.subtitle} />
      <div className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-3">
        {(c.images || []).filter((im) => im.url).map((im, i) => (
          <figure key={i} className="group overflow-hidden rounded-xl border border-white/10">
            <Img src={im.url} alt={im.caption} className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            {im.caption && <figcaption className="px-3 py-2 font-mono text-xs text-slate-400">{im.caption}</figcaption>}
          </figure>
        ))}
      </div>
    </SectionShell>
  );
};

export default GallerySection;
